import "./DocumentsListSkeleton.scss";

export const DocumentsListSkeleton = () => {
  return (
    <div className="docs-skeleton-container">
      {/* Search and filters row */}
      <div className="docs-skeleton-search-row">
        <div className="docs-skeleton-search-input-documents pulse"></div>
        <div className="docs-skeleton-search-button-documents pulse"></div>
        <div className="docs-skeleton-search-button-documents pulse"></div>
      </div>

      {/* Tabs and action buttons */}
      <div className="docs-skeleton-tabs-row">
        <div className="docs-skeleton-tabs">
          <div className="docs-skeleton-tab-active pulse"></div>
          <div className="docs-skeleton-tab pulse"></div>
        </div>
        <div className="docs-skeleton-tabs-actions">
          <div className="docs-skeleton-action-button pulse"></div>
          <div className="docs-skeleton-action-button pulse"></div>
        </div>
      </div>

      {/* Document count */}
      <div className="docs-skeleton-count pulse"></div>

      {/* Year header */}
      <div className="docs-skeleton-year pulse"></div>

      {/* Documents grid - 2 columns */}
      <div className="docs-skeleton-grid">
        {/* Left column */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Second row of documents */}
      <div className="docs-skeleton-grid">
        {/* Left column */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Third row of documents */}
      <div className="docs-skeleton-grid">
        {/* Left column */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="docs-skeleton-document">
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
